import type { LabelHTMLAttributes, ReactNode } from 'react';
import { label, requiredMark } from './Field.css';

export function Label({
  children,
  required,
  ...rest
}: LabelHTMLAttributes<HTMLLabelElement> & { children: ReactNode; required?: boolean }) {
  return (
    <label className={label} {...rest}>
      {children}
      {required && (
        <span className={requiredMark} aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
